export default __webpack_public_path__ + "static/media/116_mobile.ecc084f8.jpg";